import { PropertyType } from 'components/UnitsFilters/types';

export const getPropertyTypeByCode = (code?: string): PropertyType =>
  code?.toUpperCase() === 'R' ? 'rent' : 'sale';
